import React, { useState, useCallback } from "react"
import PropTypes from "prop-types"

import { debounce } from "lodash"

function DebouncedInput(props) {
  const [value, setValue] = useState(props.initialValue || "")

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedEventBubble = useCallback(
    debounce(value => {
      props.onDataInput({ value: value })
    }, 1000),
    []
  )

  const _updateQuery = value => {
    setValue(value)
    debouncedEventBubble(value)
  }

  return (
    <>
      <input
        type={props.inputType || "text"}
        placeholder={props.placeholder || ""}
        value={value}
        readOnly={props.isReadOnly || false}
        onChange={evt => _updateQuery(evt.target.value)}
        className={props.className}
      />
    </>
  )
}

DebouncedInput.propTypes = {
  initialValue: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  inputType: PropTypes.string,
  isReadOnly: PropTypes.bool,
  onDataInput: PropTypes.func.isRequired,
}

export default DebouncedInput
